import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const Analytics = () => {
    const location = useLocation()

    useEffect(() => {
        if (typeof window.gtag === 'function') {
            const path = location.pathname + location.search + location.hash
            const href = window.location.origin + path

            window.gtag('event', 'page_view', {
                page_title: document.title,
                page_path: path,
                page_location: href
            })
        }
    }, [location.pathname, location.search, location.hash])

    return null
}

export default Analytics
